<template>
  <AnimatedContainer v-if="filteredBreadcrumbs">
    <ul
      ref="element"
      class="
        hide-scrollbar link -mx-6 mb-12 flex max-w-full items-center
        overflow-x-auto px-6 py-1 text-base text-red-500 transition-opacity
        print:mb-8
      "
    >
      <!-- BACK LINK -->
      <!-- <li class="slide-left mr-auto pr-2">
        <NuxtLink
          v-if="filteredBreadcrumbs.length > 1"
          :to="nextParentCrumb.url"
          class="flex shrink-0 items-center gap-1 whitespace-nowrap"
          :aria-label="nextParentCrumb.title"
        >
          <IconArrowLeft class="h-[0.7em]" />
          <span>
            {{ $t('back') }}
          </span>
        </NuxtLink>
      </li> -->

      <li
        v-for="(crumb, index) in filteredBreadcrumbs"
        :key="crumb.url"
        class="flex items-center"
      >
        <!-- CRUMBS -->
        <Component
          :is="NuxtLinkOrSpan(crumb)"
          class="slide-left whitespace-nowrap"
          :to="crumb.url"
          :aria-label="crumb.title"
        >
          {{ crumb.title }}
        </Component>

        <!-- PIPE -->
        <span
          v-if="index < filteredBreadcrumbs.length - 1"
          class="slide-left relative mx-2 shrink-0"
        >
          <IconArrowRight class="h-[0.7em]" />
        </span>
      </li>
    </ul>
  </AnimatedContainer>
</template>

<!-- eslint-disable-next-line vue/block-lang -->
<script setup>
const props = defineProps({
  withCurrentPage: {
    type: Boolean, default: true,
  },
})

const route = useRoute()

const entry = inject(EntryInjectionKey, null)

const ready = ref(false)

const element = ref(null)

const filteredBreadcrumbs = computed(() => {
  const breadcrumbs = entry.value?.breadcrumbs || entry.value?.breadcrumbsFrmStructure || []

  if (props.withCurrentPage) {
    return breadcrumbs
  }

  // Filter out the current page from the breadcrumbs
  return breadcrumbs?.filter(crumb => crumb.url !== route.path) || []
})

// Ued for the back link which is currently not used
const nextParentCrumb = computed(() => {
  let index = filteredBreadcrumbs.value.length - 1

  if (props.withCurrentPage) {
    index = filteredBreadcrumbs.value.length - 2
  }

  if (index < 0) {
    return 0
  }

  return filteredBreadcrumbs.value[index]
})

// determine whether to load AppLink or span
function NuxtLinkOrSpan(crumb) {
  if (crumb.url && route.path !== crumb.url && crumb.entry?.published) {
    return resolveComponent('NuxtLink')
  }

  return 'span'
}

onMounted(async () => {
  await nextTick()

  setScrollPosition()

  await new Promise(resolve => setTimeout(resolve, 500))

  ready.value = true
})

function isOverflowing() {
  return element.value.scrollWidth >= element.value.clientWidth
}

async function setScrollPosition() {
  if (isOverflowing()) {
    await new Promise(resolve => setTimeout(resolve, 500))

    element.value.scrollLeft = element.value.scrollWidth
  }
}
</script>
